import styled from 'styled-components';

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ListBody = styled.div`
  height: 100%;
  overflow: auto;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ItemHeader = styled.div``;

export const ItemBody = styled.div`
  height: 100%;
  overflow: auto;
`;

export const DialogContents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
`;
